import { FC } from 'react';
import UserForm from '../components/users/UserForm';
import { WrapInLayout } from '../layouts';

const UserNewPage: FC = () => {
  return (
    <WrapInLayout title="New User" layout="portal">
      <UserForm />
    </WrapInLayout>
  );
};

export default UserNewPage;
